import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import Select from 'react-select';
import {downloadFile, getAxiosResponse, postAxiosResponse, putAxiosResponse} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import Constants from "../../../Constants";
import $ from "jquery";
import SuccessMessage from "../../SuccessMessage";
import axios from "axios";
import { CrossIcon } from "../../../AppIcons";
import { ConditionalBlock } from "../../../ConditionalBlock";
import { RotatingLines } from "react-loader-spinner";
import dateUtil, {DATE_FORMATS} from "../../../services/DateUtil";

const chunkSize = Constants.CHUNK_SIZE;

export default function DiscussionDetails(prop) {
    const projectId = prop.id;
    const topicId = prop.topicId;
    const [notifyUsers, setNotifyUsers] = useState([]);
    const [selectedNotifyUser, setSelectedNotifyUser] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [followers,setFollowers] = useState([]);
    const [showEdit,setShowEdit] = useState(false);
    const [topic,setTopic] = useState({});
    const [date,setDate] = useState("");
    const [followersName, setFollowersName] = useState("");
    const [vendor, setVendor] = useState("");
    const [showRemoveMe, setRemoveMe] = useState(false);
    const [showNotificationUsers, setShowUsers] = useState([]);
    const [dateWiseResponse,setDateWiseResponse] = useState([]);
    const [chatText,setChatText] = useState("");
    const [refreshPage,setRefreshPage] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [successMsg, setSuccessMsg] = useState(Constants.BLANK);
    const [message, setMessage] = useState(Constants.BLANK);
    const [selectedfile, setSelectedFile] = useState("");
    const [currentChunkIndex, setCurrentChunkIndex] = useState(-1);
    const [fileUploadProgress, setFileUploadProgress] = useState(0);
    const [pendingChat,setPendingChat] = useState(false);
    const [documentFileId, setDocumentFileId] = useState(-1);
    const [loadingTopicDetails, setLoadingTopicDetails] = useState(true);
    const owner = useSelector(
        (loginSessionDetail) => loginSessionDetail.loginSession
    ).value

    const backToList = () =>{
        prop.toggleTopicList(false);
    }
    const custBootstrapDataRedux = useSelector((store) => store.customer_bootstrap_data).value;
    useEffect(()=>{
        $(".success-message").attr("id","editMsg");
        if(successMsg!==Constants.BLANK){
          setTimeout(function(){
            setSuccessMsg(Constants.BLANK);
          },5000);
        }
    },[successMsg]);
    useEffect(()=>{
        $('.backFocus').trigger('focus')
       },[])
    useEffect(()=>{
        let messages = dateWiseResponse;
        let date = dateUtil.format(new Date());
        if(messages[date]){
            let chats = messages[date];
            chats.push(message);
        }else{
            messages[date] = [message];
        }
        setDateWiseResponse(messages);
        scrollSmoothlyToBottom("main-chat");
    },[message]);

    useEffect(() => {
        if(!showEdit){
            fetchDiscussion();
            getProject();
            fetchProjectFollowers();
            fetchDepartmentFollowers();
        }else{
            getProject();
            fetchProjectFollowers();
            fetchDepartmentFollowers();
        }
    }, [showEdit,refreshPage]);

    const fetchDiscussion = () => {
        getAxiosResponse(APIUrls.TOPIC_BY_ID(projectId,topicId))
        .then((res) => {
            if (res.data.code === 200) {
                const topic = res?.data?.data;
                setTopic(topic);
                setDate(topic?.createdDate?.date);
                let followerName = "";
                let vendor = "";
                const users = topic.followers.filter((o)=>(o.customerUser))
                    .map((o)=>{
                        if(o.customerUser.userId === owner.id){
                            setRemoveMe(true);
                        }
                        if(followerName!==""){
                            followerName += `, ${o.customerUser.firstName} ${o.customerUser.lastName}`;
                        }else{
                            followerName = `${o.customerUser.firstName} ${o.customerUser.lastName}`;
                        }
                        let roleName = o.customerUser.roleSet.displayName;
                        return ({label:`${o.customerUser.firstName} ${o.customerUser.lastName} (${roleName})`,value:o.customerUser.userId,isVendor:false})
                    });
                topic.followers.filter((o)=>(o.vendor))
                    .forEach((o)=>{
                        if(vendor!==""){
                            vendor += `, ${o.vendor.name}`;
                        }else{
                            vendor = `${o.vendor.name}`;
                        }
                        users.push({value:o.vendor.id,label:o.vendor.name,isVendor:true});
                    });
                if(vendor){
                    followerName = `${vendor}, ${followerName}`;
                }
                let messages = [];
                let dateWiseMessages = {};
                topic.responses.map((response)=>{
                    let date = dateUtil.format(response.createdDate);
                    let message = {
                        id:response.id,
                        isCreator:response.creatorUser.userId === owner.id,
                        text:response.text,
                        createdDate:response.createdDate,
                        time: dateUtil.format(response.createdDate, DATE_FORMATS.TIME_OF_DAY),
                        initials:getNameInitials(response.creatorUser),
                        attachment:response.attachment,
                        creatorName:`${response.creatorUser.firstName} ${response.creatorUser.lastName}`         
                    };
                    if(dateWiseMessages[date]){
                        let messages = dateWiseMessages[date];
                        messages.push(message);
                    }else{
                        dateWiseMessages[date] = [message];
                    }
                });
                setDateWiseResponse(dateWiseMessages);
                setShowUsers(users);
                setFollowersName(followerName);
                setVendor(vendor);
                scrollSmoothlyToBottom("main-chat");
            }
        }).catch((err) => {
            console.error(err);
        }).finally(() => {
          setLoadingTopicDetails(false);
        });
    };

    useEffect(()=>{
        populateNotifyUsers(true,true,true);
    },[allUsers,followers,vendors,showNotificationUsers]);
    
    const getProject = () =>{
        getAxiosResponse(APIUrls.PROJECT(projectId))
        .then((response)=>{
          if(response.data.code ===200){
            let vendors = response.data.data.resource.projectResource.vendorsWithActiveProjectAccess
            .map((vendor)=>
            ({value:vendor.id,label:vendor.name,isMachine:vendor.machineTranslationVendor,isVendor:true})
            );
            setVendors(vendors);
          }
        }).catch((err)=>{
          console.error(err);
        });
    };
    
    const fetchProjectFollowers = ()=>{
        getAxiosResponse(APIUrls.PROJECT_FOLLOWER_USER(projectId))
        .then((res) => {
          if (res.data.code === 200) {
            let users = res.data.data.filter((resource)=> (owner.id !== resource.resource.userId))
            .map(({ resource,displayName }) => ({value: resource.userId,
                  label: resource.firstName+' '+resource.lastName+' ('+displayName[0]?.roles[0]+')', isVendor:false
                }));
            setFollowers(users);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };
    
    const fetchDepartmentFollowers = () =>{
        getAxiosResponse(APIUrls.PROJECT_VISIBILITY_USER(projectId))
        .then((res) => {
          if (res.data.code === 200) {
            let users = res.data.data.filter((resource)=>(owner.id !== resource.userId))
            .map(({ resource,displayName }) => ({
                  value: resource.userId,
                  label: resource.firstName+' '+resource.lastName+' ('+displayName[0].displayName+')',isVendor:false
                }));
          setAllUsers(users);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };
    
    const populateNotifyUsers = (isVendor,isFollower,isUser)=>{
        let data = [{ key: "0", label: "-- Add Recipients --", value: "" }];
        if(isVendor){
          data.push({ key: "0", label: "-- Select All Vendors --", value: "all-vendor" });
          vendors.forEach((vendor)=>{
            if(!vendor.isMachine){
                let selectedVendor = showNotificationUsers.find((o)=> o.value === vendor.value);
                !selectedVendor && data.push(vendor);
            }
          });
        }
        if(isFollower){
          data.push({key: "1",value: "all-follower",label: "-- Select All Project Followers --"});
          followers.forEach((follower)=>{
            let selectedFollower = showNotificationUsers.find((o)=> o.value === follower.value);
            !selectedFollower && data.push(follower);
          });
        }
        if(isUser){
          data.push({key: "2",value: "other-dept-users",label: "-- Other Users In Department --"});
          allUsers.forEach((user)=>{
            let follower = followers.find((val)=>(val.value === user.value));
            let selectedFollower = showNotificationUsers.find((o)=> o.value === user.value);
            if(!follower && !selectedFollower){
              data.push(user);
            }
          });
        }
        setNotifyUsers(data);
    };

    const removeMe = ()=>{
        let topic1 = {
            id:topic.id,
            followers:[]
        };
        let data = [];
        topic.followers.forEach((o)=>{
            if(o.vendor){
                data.push({vendor:{id:o.vendor.id,name:o.vendor.name}});
            }else{
                if(o.customerUser.userId!==owner.id){
                    data.push({customerUser:{userId:o.customerUser.userId}});
                }
            }
        })
        topic1.followers=data;
        updateTopic(topic1,false);
    };

    const addMe = ()=>{
        let topic1 = {
            id:topic.id,
            followers:[]
        };
        let data = [{customerUser:{userId:owner.id}}];
        topic.followers.forEach((o)=>{
            if(o.vendor){
                data.push({vendor:{id:o.vendor.id,name:o.vendor.name}});
            }else{
                data.push({customerUser:{userId:o.customerUser.userId}});
            }
        });
        topic1.followers=data;
        updateTopic(topic1,true);
    };

    const updateTopic = (topic,removeMe)=>{
        putAxiosResponse(APIUrls.TOPIC_BY_ID(projectId,topic.id),topic)
        .then((response)=>{
            if(response.data?.code===200){
                setRemoveMe(removeMe);
                setRefreshPage(refreshPage?false:true);
                setSuccessMsg("Changes done successfuly")
                setTimeout(function(){
                    $('.afterSuccessFocus').trigger('focus')
               },4000);
            }
        }).catch((err)=>{
            console.error(err);
        });
    };

    const showModal = () =>{
        showEdit ? setShowEdit(false) : setShowEdit(true);
        const btn = $("#confirm-btn");
        if(!btn.hasClass("disabled-data")){
            btn.add("disabled-data");
        }
       setTimeout(() => {
            document.body.classList.add("gb-modal-open");
         }, 200);
         setTimeout(() => {
          $(".first-focus").trigger("focus");
          $("#focusSelect .cw__input").on("keydown", function (e) {
            if (e.key === Constants.TAB) {
             if (e.shiftKey === true) {
                e.preventDefault();
                $("#confirm-btn").trigger("focus");
              }
            }
          });
          $(".inner-lightbox-panel").on("keydown", function (e) {
            if (e.key === Constants.ESCAPE) {
              hideModel();
             }
          });
        }, 500);
    };

    const handleKeyEditflow = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            $("#focusSelect .cw__input").trigger("focus");
          }
        }
      };

    const hideModel = ()=>{
        showEdit ? setShowEdit(false) : setShowEdit(true);
        document.body.classList.remove("gb-modal-open");
        $('.editFocus').trigger('focus')
    };

    const removeItem = (user) => {
        enableConfirmButton();
        setShowUsers((current) =>
          current.filter(
            (showNotificationUsers) => showNotificationUsers.value !== user.value
          )
        );
        setNotifyUsers((current) => [...current,user]);
        const selectedElement = $(document.activeElement).closest(".multiselect-output");
        if($(document.activeElement).is(':last-child') &&
        selectedElement.children().length > 1){
            selectedElement.find('button:nth-last-child(2)').trigger('focus');
        } else if($(document.activeElement).is(':last-child')){
        $(document.activeElement).closest(".lightbox-content").find('.global-dropdown-block input:first-of-type').trigger('focus');
        }
    };

    const enableConfirmButton = ()=>{
        const btn = $("#confirm-btn");
        if(btn.hasClass("disabled-data")){
            btn.removeClass("disabled-data")
        }
    };

    const handleNotifyUserChange = (event) => {
        let selectedId = event.value;
        if(event.value === "all-vendor"){
          setShowUsers(vendors);
        }else if (event.value === "all-follower") {
          setShowUsers(followers);
        }
        else if(event.value === "other-dept-users"){
          setShowUsers(allUsers);
        }else {
          let result = notifyUsers.find(({ value }) => value == selectedId);
          setShowUsers(current => [...current, result]);
        }
        enableConfirmButton();
        setSelectedNotifyUser(current => [...current, event.value]);
    };

    const updateFollowers = ()=>{
        let topic1 = {
            id:topic.id,
            followers:[]
        };
        const folloerIds = showNotificationUsers.map((o)=>{
            if(o.isVendor){
                return ({vendor:{id:o.value}});
            }else{
                return ({customerUser:{userId:o.value}});
            }
        });
        topic1.followers = folloerIds;
        putAxiosResponse(APIUrls.TOPIC_BY_ID(projectId,topic1.id),topic1)
        .then((response)=>{
            if(response.data?.code===200){
               setSuccessMsg("Followers updated.")
               setTimeout(() => {
                hideModel();
                }, 100);
                setTimeout(() => {
                    $('.editFocus').trigger('focus')
                 }, 5000);
            }
        }).catch((err)=>{
            console.error(err);
        });
    };

    const LeftChat = (props)=>{
        const message = props.message;
        return(
            <div className='left-chat-msg flex'>
                <div className='chat-user-name'>
                    <span>{message.initials}</span>
                </div>
                <div className='user-chat-text'>
                    <div className='time flex-center'>
                        <strong>{message.creatorName}</strong>
                        <span>{message?.time}</span>
                    </div>
                    <div className='chat-bubble-list'>
                        <div className='chat-bubble'>
                            {message.text}
                        </div>
                    </div>
                    {message.attachment?<MessageAttachment attachment={message.attachment} responseId={message.id} />:Constants.BLANK}
                </div>
            </div>
        );
    };

    const MessageAttachment = (prop)=>{
        const attachment = prop.attachment;
        const responseId = prop.responseId;
        return(
            <>
                <div className="chat-attach-text">
                    <a tabIndex="0" aria-label={"download " + `${attachment.filename}`}
                     onClick={()=>downloadMessageAttachment(attachment.filename,responseId)}
                     onKeyDown={(e)=>EnterdownloadMessageAttachment(e,attachment.filename,responseId)}
                     >
                        {attachment.filename}
                    </a> 
                    <span>{attachment.sizeInKilobytes}{" "}kb</span>
                </div>
            </>
        );
    };

    const RightChat = (props) =>{
        const message = props.message;
        return(
            <div className='right-chat-msg flex'>
                    <div className='user-chat-text'>
                        <div className='time flex-center'>
                            <span>{message?.time}</span>
                            <strong>{message.creatorName}</strong>
                        </div>
                        <div className='chat-bubble-list'>
                            <div className='chat-bubble'>
                                {message.text}
                            </div>
                        </div>
                        {message.attachment?<MessageAttachment attachment={message.attachment} responseId={message.id} />:Constants.BLANK}
                    </div>
                    <div className='chat-user-name'>
                        <span>{message.initials}</span>
                    </div>
            </div>
        );
    };
    
    const sendMessage = ()=>{
        if(chatText!==Constants.BLANK && pendingChat === false){
            const message = {
                text:chatText,
                time:"now",
                initials:getNameInitials(owner),
                creatorName:`${owner.firstName} ${owner.lastName}`,
                isCreator:true
            };
            setMessage(message);
            sendMessageToTopic();
        }
    };

    const setChatTextValue = (e)=>{
        setChatText(e.target.value);
    };

    const sendMessageOnEnter = (e)=>{
        if(e.keyCode ===13){
            sendMessage();
        }
    }

    const sendMessageToTopic = ()=>{
        const params = getParams();
        createTopicResponseMetaData(params);
    };

    const getParams = (size) =>{
        let params = new URLSearchParams();
        params.set("projectId",projectId);
        params.set("topicId",topic.id);
        params.set("text",chatText);
        if(selectedfile){
            params.set("name", selectedfile.name);
            params.set("size", selectedfile.size);
            params.set("currentChunkIndex", currentChunkIndex);
            params.set("totalChunks", Math.ceil(selectedfile.size / chunkSize));
            params.set("fileDataAttribute","attachment.fileData");
            params.set("attachment.filename",selectedfile.name);
            if(size){
                params.set("attachment.sizeInKilobytes",size);
            }else{
                params.set("attachment.sizeInKilobytes",selectedfile.size);
            }
        }
        params.set("hasDocument", selectedfile?true:false);
        params.set("documentFileId",(documentFileId!==-1)?documentFileId:"");
        return params;
    };

    const downloadAttachment = (fileName)=>{
        const url = APIUrls.TOPIC_ATTACHMENT(projectId,topicId);
        downloadFile(url,fileName);
    };
    const attachmentData = (event, fileName)=>{
        if (event.key === Constants.ENTER) {
          const url = APIUrls.TOPIC_ATTACHMENT(projectId,topicId);
          downloadFile(url,fileName);
        }
    };
    

    const downloadMessageAttachment = (fileName,responseId)=>{
        const url = APIUrls.TOPIC_MESSAGE_ATTACHMENT(projectId,topicId,responseId);
        downloadFile(url,fileName);
    }
    const EnterdownloadMessageAttachment = (event,fileName,responseId)=>{
        if (event.key === Constants.ENTER) {
          const url = APIUrls.TOPIC_MESSAGE_ATTACHMENT(projectId,topicId,responseId);
          downloadFile(url,fileName);
        }
    }

    const fileSelection = (e)=> {
        if (e.target) {
            setSelectedFile(e.target.files[0]);
            $("#chat-area").removeClass("conditional-width")
        }else{
            $("#chat-area").addClass("conditional-width");
        }
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (!+bytes) return "0 Bytes";
        const k = 1024;
        let dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        let i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    };

    useEffect(()=>{
        if(currentChunkIndex !== -1){
          readAndUploadCurrentChunk();
        }
    },[currentChunkIndex]);
          
    const readAndUploadCurrentChunk=()=> {
        const file = selectedfile;
        if (file) {
          const reader = new FileReader();
          const from = currentChunkIndex * chunkSize;
          const to = from + chunkSize;
          const blob = file.slice(from, to);
          reader.onload = (e) => uploadChunk(e,blob.size);
          reader.readAsDataURL(blob);
        }else{
          uploadChunk(null,null);
        }
    };

    const uploadChunk=(readerEvent,size) =>{
        const file = selectedfile;
        const data = readerEvent ? readerEvent.target.result : {};
        const headers = {
          "Content-Type": "application/octet-stream",
          "CSRF-Token": localStorage.getItem("csrfToken"),
        };
        let params = getParams(size);
        const urlPart = (file ? APIUrls.TOPIC_CREATE_RESPONSE : APIUrls.TOPIC_CREATE_RESPONSE.replace("/upload",""))+"?"+params.toString();
        const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
        axios.post(url, data, { headers }).then((response)=>{
            if(response?.data?.code === 200){
                if(selectedfile){
                    const filesize = selectedfile.size;
                    const chunks = Math.ceil(filesize / chunkSize) - 1;
                    const isLastChunk = currentChunkIndex === chunks;
                    if (isLastChunk) {
                        setCurrentChunkIndex(-1);
                        setFileUploadProgress(100);
                        setRefreshPage(refreshPage?false:true);
                        setChatText("");
                        setSelectedFile("");
                        setPendingChat(false);
                        $("#chat-area").addClass("conditional-width");
                    } else {
                        const chunks = Math.ceil(filesize / chunkSize);
                        setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
                        setCurrentChunkIndex(currentChunkIndex + 1);
                    }
                }else{
                    setCurrentChunkIndex(-1);
                    setRefreshPage(refreshPage?false:true);
                    setChatText("");
                    setSelectedFile("");
                    setPendingChat(false);
                    $("#chat-area").addClass("conditional-width");
                }
            }
        });
      };

    const createTopicResponseMetaData = (params)=>{
        setPendingChat(true);
        let url = `${APIUrls.TOPIC_CREATE_RESPONSE_METADATA}?${params.toString()}`;
        postAxiosResponse(url)
        .then((response)=>{
            if(response?.data?.code === 200){
                if (response?.data?.data) {
                    setDocumentFileId(response?.data?.data);
                    setCurrentChunkIndex(0);
                }else{
                    setCurrentChunkIndex(0);
                }
            }
        }).catch((err)=>{
            console.error(err);
        });
    };

    const getNameInitials = (user)=>{
        return `${user.firstName?.charAt(0)?.toUpperCase()}${user.lastName?.charAt(0)?.toUpperCase()}`;
    };

    const scrollSmoothlyToBottom = (id) => {
        setTimeout(()=>{
            const element = $(`#${id}`);
             element.animate({
               scrollTop: element.prop("scrollHeight")
            }, 500);
        },1000);
    };

    //removed it as per discussed with Bharti but having it here if requires to put it in future
    const EmojiButton = ()=>{
        return (
            <button className='emoji-icon'>
                <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M8.28025 2.07987C7.14591 2.31278 6.06841 2.76602 5.10878 3.41379H5.10788L5.08265 3.43065C3.13115 4.73484 1.77766 6.76084 1.31994 9.06295C0.862222 11.3651 1.33776 13.7547 2.64195 15.7062C3.94613 17.6577 5.97213 19.0112 8.27425 19.4689C10.5762 19.9266 12.9657 19.4512 14.9172 18.1472C15.8937 17.5061 16.7336 16.678 17.3886 15.7107C18.0435 14.7433 18.5005 13.6558 18.7331 12.5109C18.9657 11.3659 18.9693 10.1863 18.7437 9.04002C18.518 7.89372 18.0677 6.80343 17.4186 5.83205C16.7695 4.86067 15.9345 4.02742 14.9618 3.38036C13.9891 2.7333 12.8978 2.28525 11.7511 2.06204C10.6043 1.83884 9.42467 1.8449 8.28025 2.07987ZM10.0008 14.4388L10.0005 14.4388C9.33934 14.4404 8.69019 14.2624 8.12233 13.9239C7.55447 13.5853 7.08924 13.0988 6.7763 12.5165L6.72844 12.4274L6.63991 12.4762L5.55241 13.0762L5.46561 13.1241L5.51274 13.2113C5.95918 14.0375 6.62505 14.7243 7.43696 15.1962C8.24887 15.668 9.1753 15.9066 10.1141 15.8855C11.053 15.8644 11.9677 15.5845 12.7576 15.0766C13.5475 14.5688 14.1819 13.8527 14.5907 13.0073L14.6345 12.9169L14.5438 12.8736L13.4188 12.3361L13.3292 12.2932L13.2858 12.3826C12.9865 12.9992 12.5196 13.5191 11.9387 13.8827C11.3577 14.2463 10.6861 14.439 10.0008 14.4388ZM8.56176 18.0628C7.60619 17.8689 6.69836 17.4881 5.89045 16.9422C4.26983 15.8472 3.14864 14.1551 2.77195 12.2358C2.39527 10.3166 2.79373 8.32622 3.88023 6.69988C4.96674 5.07355 6.65292 3.9435 8.57018 3.55675C10.4874 3.17 12.4798 3.55802 14.1119 4.63598C14.9254 5.17337 15.6248 5.86625 16.1698 6.67479C16.7147 7.48333 17.0945 8.3916 17.2873 9.3474C17.4801 10.3032 17.4821 11.2877 17.2932 12.2442C17.1043 13.2008 16.7283 14.1106 16.1866 14.9214C15.645 15.7322 14.9484 16.4279 14.137 16.9686C13.3256 17.5093 12.4154 17.8843 11.4586 18.0721C10.5018 18.2599 9.51733 18.2567 8.56176 18.0628ZM7.83031 10.4934C8.08348 10.2402 8.22572 9.89683 8.22572 9.53879C8.22572 9.18075 8.08348 8.83737 7.83031 8.5842C7.57714 8.33102 7.23376 8.18879 6.87572 8.18879C6.51767 8.18879 6.17429 8.33102 5.92112 8.5842C5.66795 8.83737 5.52572 9.18075 5.52572 9.53879C5.52572 9.89683 5.66795 10.2402 5.92112 10.4934C6.17429 10.7466 6.51767 10.8888 6.87572 10.8888C7.23376 10.8888 7.57714 10.7466 7.83031 10.4934ZM14.0803 10.4934C14.3335 10.2402 14.4757 9.89683 14.4757 9.53879C14.4757 9.18075 14.3335 8.83737 14.0803 8.5842C13.8271 8.33102 13.4838 8.18879 13.1257 8.18879C12.7677 8.18879 12.4243 8.33102 12.1711 8.5842C11.9179 8.83737 11.7757 9.18075 11.7757 9.53879C11.7757 9.89683 11.9179 10.2402 12.1711 10.4934C12.4243 10.7466 12.7677 10.8888 13.1257 10.8888C13.4838 10.8888 13.8271 10.7466 14.0803 10.4934Z" fill="#6B7C93" stroke="#6B7C93" strokeWidth="0.2"/>
                </svg>
            </button>
        );
    }
    /*As discussed with Bharti changed the button text to Back*/
    return (
    <div>
        <div className="campaign_details-task-create-form">
            <div className="projects-heading">
            <h5>{topic.subject}</h5>
            <button className="btn-bold backFocus" onClick={backToList}>Back</button>
            </div>
            <div className="discussion-outer">
                <div className="left">
                    <div className="discussion-table">
                        <ul>
                            <li>
                                <div className="title">Date</div>
                                <div className="relative text">
                                <span className="font-zero setFastpass"
                                    >
                                    {date}
                                </span>
                                    <span aria-hidden="true">{date}</span>
                                </div>
                                
                            </li>
                            <li>
                                <div className="title">From</div>
                                <div className="text">{topic.creatorDisplayName}</div>
                            </li>
                            <li>
                                <div className="title">Notifications will be sent to</div>
                                <div className="text">
                                    <p>{followersName}</p>
                                    <div className="btn-wrap btn-gap align-items">
                                        <button aria-describedby="editMsg" className="inline-flex editFocus" onClick={showModal}>Edit</button>
                                        {showRemoveMe?<button className="inline-flex afterSuccessFocus"  onClick={removeMe}>Remove Me</button>:<button   className="inline-flex afterSuccessFocus" onClick={addMe}>Add Me</button>}
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="title">Who will have access to this discussion?</div>
                                <div className="text">{vendor!==Constants.BLANK? vendor+", Your internal company users" :"Your internal company users"}</div>
                            </li>
                            <li>
                                <div className="title">Discussion</div>
                                {loadingTopicDetails
                                  ? (<div className="text">Loading...</div>)
                                  : topic.text && (<div className="text discussion-topic-text">{topic.text.split("\n").map(line => (<>{line}<br></br></>))}</div>)}
                            </li>
                            {topic.attachment?
                                <li>
                                    <div className="title">Attachment</div>
                                    <a tabIndex="0" className="attach-breakText" onClick={()=>downloadAttachment(topic.attachment?.filename)}
                                     onKeyDown={(e)=>attachmentData(e,topic.attachment?.filename)}
                                    >{topic.attachment?.filename}&nbsp;</a>{topic.attachment?.sizeInKilobytes}{" "}kb
                                </li>
                            :Constants.BLANK
                            }
                        </ul>
                    </div>
                </div>
                <div className="right chatbox-block">
                    <div id="main-chat" className='main-chatbox-container'>
                    {
                        Object.entries(dateWiseResponse).map((k,i)=>{
                            return (
                            <>
                                <div className='date-line' key={i}>
                                    <span>{k[0]}</span>
                                </div>
                                {k[1].map((message,index)=>{
                                    return ((message.isCreator)
                                                ?<RightChat message = {message} key={index}/> 
                                                : <LeftChat message = {message} key={index}/>);
                                })
                                }
                            </>
                            )
                        })
                    }
                    </div>
                    <div id="chat-area" className="chat-inputarea conditional-width flex">
                        <div className="chat-icon flex-center btn-gap">
                            <div className="attachment-icon">
                                <input type="file" id="chat-file" className="hide" onChange={fileSelection} />
                                <label htmlFor="chat-file">
                                    <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                        <path d="M12.4966 6.0589L11.216 4.85666L4.81261 10.8726C4.56042 11.1097 4.36039 11.3911 4.22394 11.7008C4.08749 12.0105 4.01729 12.3424 4.01735 12.6776C4.01741 13.0128 4.08773 13.3447 4.22428 13.6543C4.36084 13.964 4.56097 14.2454 4.81324 14.4823C5.06551 14.7193 5.36498 14.9073 5.69456 15.0355C6.02413 15.1637 6.37736 15.2297 6.73406 15.2296C7.09077 15.2296 7.44397 15.1635 7.7735 15.0352C8.10303 14.9068 8.40244 14.7188 8.65462 14.4817L16.3387 7.26234C17.1876 6.46441 17.6645 5.38226 17.6644 4.25393C17.6643 3.12561 17.1872 2.04354 16.338 1.24577C15.4889 0.448007 14.3373 -0.000111155 13.1365 2.06817e-08C11.9358 0.000111197 10.7843 0.448443 9.9353 1.24637L1.8677 8.8262L1.85003 8.84162C-0.616678 11.1596 -0.616678 14.9157 1.85003 17.2324C4.31675 19.5492 8.31395 19.5492 10.7807 17.2324L10.7971 17.2158L10.7983 17.217L16.3058 12.0429L15.0252 10.8406L9.51766 16.0136L9.50126 16.029C8.65606 16.8217 7.51072 17.2668 6.31661 17.2668C5.1225 17.2668 3.97716 16.8217 3.13197 16.029C2.71302 15.6345 2.38107 15.1661 2.15514 14.6508C1.92922 14.1354 1.81377 13.5832 1.81541 13.0259C1.81705 12.4685 1.93575 11.9169 2.16471 11.4028C2.39366 10.8886 2.72837 10.422 3.14963 10.0296L3.14837 10.0284L11.2172 2.44861C12.2758 1.45267 13.9994 1.45267 15.0592 2.44861C16.1191 3.44456 16.1178 5.06296 15.0592 6.05772L7.37522 13.2771C7.20325 13.4258 6.97683 13.5062 6.74323 13.5017C6.50963 13.4972 6.28693 13.408 6.12163 13.2528C5.95634 13.0977 5.86124 12.8885 5.85619 12.669C5.85114 12.4495 5.93654 12.2366 6.09454 12.0749L12.4979 6.05772L12.4966 6.0589Z" fill="#6B7C93"></path>
                                    </svg>
                                </label>
                            </div>
                            <div id="file-name" className="file-text">
                                <span className="ext-name" title={selectedfile?.name}>{selectedfile?.name}</span>
                                <span className="file-size">
                                {formatBytes(selectedfile?.size)}
                                </span>
                            </div>
                        </div>
                        
                        
                        <div className='right-chat-input'>
                            <input type="text" className="msger-input" placeholder="Add a comment..." value={chatText} onChange={e=>setChatTextValue(e)} onKeyDown={(e)=>{sendMessageOnEnter(e)}}/>
                            <ConditionalBlock condition={pendingChat === true}>
                                <div className='chat-send-btn aaa-change-icon'>
                                    <RotatingLines strokeColor="#1D4ED8" strokeWidth="5" animationDuration="0.75" width="22" visible={true} />
                                </div>
                            </ConditionalBlock>
                            <ConditionalBlock condition={pendingChat === false}>
                                <button type="submit" aria-label="send message" className='chat-send-btn' onClick={sendMessage}>
                                    <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M8.64233 9.99984H3.49254L1.77042 3.44567C1.7594 3.40758 1.75268 3.36847 1.75039 3.329C1.73123 2.72817 2.42286 2.3115 3.02216 2.5865L19.1719 9.99984L3.02216 17.4132C2.42983 17.6857 1.74691 17.2807 1.75039 16.6907C1.75215 16.638 1.76183 16.5858 1.77913 16.5357L3.057 12.4998" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            </ConditionalBlock>
                        </div>
                    </div>
                </div>
            </div>
            <div id="modelPopup" className="lightbox-panel discussion-popup bid-extended" aria-labelledby="addRecipients" role="dialog">
                <div className="inner-lightbox-panel">
                    <div className="modal-header flex">
                        <strong id="addRecipients">Add Recipients to Discussion</strong>
                    </div>
                    <div className="lightbox-content overflow-inherit">
                        <div id="focusSelect" className="global-dropdown-block flex-column mar-bot10">
                            <label>Add Recipients</label>
                            <Select className="global-dropdown-select" classNamePrefix='cw'
                            hideSelectedOptions={true}
                             placeholder="-- Add Recipients -- "
                             aria-label="Add Recipients"
                             options={notifyUsers}
                             value={notifyUsers && notifyUsers[0]}
                             onChange={e => handleNotifyUserChange(e)}
                            />
                        </div>
                        <div className="multiselect-output flex">
                            {showNotificationUsers.map((user,index) => {
                                return (
                                   <button key={index} aria-label={"remove " + user.label }>
                                        <strong>
                                            {user.label}
                                        </strong>
                                        {user.isVendor?'':
                                            <span onClick={() => removeItem(user)}>
                                                {CrossIcon}
                                            </span>
                                        }
                                    </button>
                                );
                            })}
                            </div>
                    </div>	
                    <div className="modal-footer flex">
                                <button className="btn btn-bold first-focus" onClick={hideModel}>Cancel</button>
                                <button id="confirm-btn" className="btn btn-bold active disabled-data" onClick={updateFollowers}
                                onKeyDown={handleKeyEditflow}
                                >Confirm</button>
                    </div>
                </div>		
            </div>
        </div>
        {(successMsg!==undefined && successMsg !== Constants.BLANK)?<SuccessMessage message={successMsg}/>:Constants.BLANK}
    </div>
  )
}
